import styled from 'styled-components'
export default styled.span`
  color: ${ ({ theme }) => theme.colors.grey };
  font-family: ${ ({ theme }) => theme.font.secondary };
  font-size: 1.4rem;
  line-height: 2;
  vertical-align: bottom;
`
